import React from 'react';

import { Flex } from '../common/atom/Layout';
import { HorizonGreyLine } from '../common/atom/HorizonGreyLine';
import { Text } from '../common/atom/Text';
import { EmptyMessage } from '../common/organism/EmptyMessage';

import ReviewPossibleListItem from './ReviewPossibleListItem';
import * as PATH from '../../lib/routes/path';
import ThemeStyle from '../../lib/style/ThemeStyle';

const ReviewPossibleList = ({ data: reviewableList }) => {
  return (
    <Flex column padding="1.875rem 0 0">
      <Flex column>
        <Text size={16} color="orangePink" lineHeight={'1.25rem'}>
          리뷰 등록시 페이백 지급!
        </Text>
        <Text size={14} color="brownGrey" lineHeight={'1.25rem'}>
          페이백은 결제하신 카드나 계좌로 환급 됩니다
        </Text>
      </Flex>
      {reviewableList.length > 0 ? (
        <Flex column padding="0.625rem 0 1.25rem" width="100%">
          <Text
            size={16}
            weight="regular"
            lineHeight={'1.25rem'}
            textAlign="center"
            style={{
              borderBottom: `1px solid ${ThemeStyle.color.pinkishGrey}`,
              width: '100%',
              paddingBottom: '1.25rem',
            }}
          >
            <b>{reviewableList.length}개</b>의 리뷰가 작성 대기중입니다
          </Text>
          {reviewableList.map((reviewable, index) => (
            <React.Fragment key={index}>
              <ReviewPossibleListItem
                id={reviewable.purchasedItem.id}
                categoryName={reviewable.category.name}
                storageUri={reviewable.category.thumbnail.storageUri}
                itemName={reviewable.purchasedItem.itemName}
                createDateTime={reviewable.purchasedItem.createDateTime}
              />
              {index !== reviewableList.length - 1 && <HorizonGreyLine />}
            </React.Fragment>
          ))}
        </Flex>
      ) : (
        <EmptyMessage
          messageList={[
            '아직 주문 내역이 없습니다.',
            '100% 리얼 후기 보러 가 볼까요?',
          ]}
          buttonPath={PATH.REVIEW}
          buttonTitle="리뷰보러 가기"
        />
      )}
    </Flex>
  );
};

export default ReviewPossibleList;
